module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_floral_champagne-989b64ea.png";